import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function OnboardingBanner() {
  const navigate = useNavigate();
  return (
    <Box sx={{ bgcolor: 'background.paper', border: 1, borderColor: 'divider', p: 2, mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
      <Box>
        <Typography variant="h6">Finish setting up your workspace</Typography>
        <Typography variant="body2" color="text.secondary">Complete onboarding to create your company, locations, and team. Your workspace will be private to your account.</Typography>
      </Box>
      <Box>
        <Button variant="contained" color="primary" onClick={() => navigate('/onboarding')}>Continue onboarding</Button>
      </Box>
    </Box>
  );
}
